<template>
  <m-geo-box geo-option="polygon">
    <m-question :link="$store.getters['config/link']('radiusQuestion')"></m-question>
    <div class="box-t">
    <div class="header">
      <h3>Select Target Area(s) - Polygon Map</h3>
    </div>
    <b-container fluid>
      <div :class="{'map-full-screen-input': fullScreen}">
        <b-row >
          <b-col md="7" class="m-col-top">
            <input id="polygon-address"
                   placeholder="Enter a ZIP Code or Address"
                   @keyup.enter="search"
                   class="address-input form-control"
                   ref="polygonAddress"
                     v-model="address" />
          </b-col>
          <b-col md="5" class="flex-center m-col-top">
            <span style="margin-right: 16px; ">Granularity</span>
            <b-form-select
                data-test="geo-polygon-granularity"
                class="address-input"
                v-model="granularity">
              <option value="1" checked>Standard</option>
              <option value="2">ZIP4</option>
              <option value="3">Carrier Route</option>
            </b-form-select>
            <icon name="question-circle"
                  title="help"
                  style="color: #3C96D2; height:24px;width:72px; margin-left: 16px; cursor: pointer "
                  @click.native="$root.$emit('bv::show::modal', 'question')"/>
          </b-col>
        </b-row>
        <b-row class="m-row-top">
          <b-col md="3">
            <b-form-radio-group v-model="boundsTypeSelected" style="display: flex;" name="boundsType">
            <b-form-radio value="CR">Carrier Routes
            </b-form-radio>
              <b-form-radio value="ZIP">ZIP Codes
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-col>
            <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
            <b-btn variant="primary" @click="startPolygon()"
                   data-test="geo-polygon-start"
                   :disabled="(orderAddress.length> 0 || isPolygonDrawing) && order.GeoType === 13">Start</b-btn>
            <b-btn @click = "clearPolygon" data-test="geo-polygon-clear">Clear</b-btn>
          </b-col>
        </b-row>

      </div>
      <b-row>
        <b-col>
          <m-map map-id = 'mapPolygon'
                 @load="createMap"
                 @full-screen="toggleFullScreen"></m-map>
        </b-col>
      </b-row>
    </b-container>
    </div>
  </m-geo-box>

</template>
<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import utils from '@/assets/utils/index'
  import MQuestion from '@/components/common/Mquestion'
  import MMap from '@/components/geo/MMap'

  export default {
    components: {
      MGeoBox,
      MQuestion,
      MMap
    },
    data () {
      return {
        address: '',
        zipType: 'ZIP',
        step: 'input',
        alertDesc: '',
        map: null,
        autoComplete: null,
        fullScreen: false,
        boundsTypeSelected: 'ZIP'
      }
    },
    computed: {
      order () {
        return this.$store.state.order
      },
      geoType () {
        return this.$store.state.geo.geoTypes.Polygon
      },
      granularity: {
        get () {
          let choice = this.$store.state.order.RadiusTypeChoice
          if (choice === null) {
            return 1
          }
          return choice
        },
        set (val) {
          this.$store.commit('order/saveKey', ['RadiusTypeChoice', parseInt(val)])
        }
      },
      orderAddress () {
        return this.$store.getters['order/orderaddress']
      },
      isPolygonDrawing () {
        return this.$store.state.geo.isPolygonDrawing
      }
    },
    watch: {
      orderAddress (val) {
        if (val.length === 0 || this.order.GeoType !== 13) {
          if (this.mpa) {
            this.map.clearPolygon()
            this.map.clearMarkers()
          }
        }
      },
      boundsTypeSelected () {
        this.map.addLayer(this.boundsTypeSelected, '', true)
      }
    },
    activated () {
    },
    methods: {
      startPolygon () {
        this.alertDesc = ''
        if (this.address === '') {
          this.alertDesc = 'Please input an address'
          return
        }
        let zoom = this.map.map.getZoom()
        if (zoom < 9) {
          alert('Please Zoom in to use the polygon mapping tool.\nTo select larger geographic regions, please use a radius select, scf, ZIP code, or county selection.')
          return
        }
        this.$store.commit('geo/saveKey', ['isPolygonDrawing', true])
        this.$store.dispatch('order/changeGeoType', this.geoType.Code)
        this.map.clearPolygon()
        this.map.textSearch(this.address, resp => {
          if (this.searchCallBack(resp.placesresult)) {
            this.map.initPolygonDrawing(resp.placesresult)
          }
        })
      },
      onPlaceChanged () {
        let place = this.autoComplete.getPlace()

        this.address = document.getElementById('polygon-address').value
        if (!this.searchCallBack(place)) {
          document.getElementById('polygon-address').placeholder = 'Enter a ZIP Code/Address'
        }
      },
      search () {
        this.map.textSearch(this.address, resp => {
          this.searchCallBack(resp.placesresult)
        })
      },
      searchCallBack (place) {
        if (!(place && place.geometry)) {
          this.alertDesc = 'No results found for address'
          return false
        }
        let marker = new this.map.googleMap.Marker({
          position: place.geometry.location
        })
        marker.setMap(this.map.map)
        this.map.markers.push(marker)
        this.map.map.panTo(place.geometry.location)
        this.map.map.setZoom(12)
        this.map.addLayer(this.boundsTypeSelected, '', true)
        return true
      },
      clearPolygon () {
        this.$store.commit('order/cleanGeo')
        this.map.clearMarkers()
        this.map.clearPolygon()
      },
      createMap () {
        this.map = utils.maps['mapPolygon']
        let that = this
        this.map.map.addListener('zoom_changed', function () {
          if (that.map.map.getZoom() >= 12) {
            that.map.addLayer(that.boundsTypeSelected, '', false)
          }
        })
        /* eslint-disable no-undef */
        this.autoComplete = new google.maps.places.Autocomplete(
          document.getElementById('polygon-address'), {
            types: ['(regions)'],
            componentRestrictions: {'country': 'us'}
          }
        )
        this.autoComplete.addListener('place_changed', this.onPlaceChanged)
        if (this.orderAddress.length > 0 && this.order.GeoType === 13 && !this.map.polygonBounder) {
          this.map.initPolygon(this.getPaths(), true, {
            address: this.orderAddress[0].AddressName,
            lat: this.orderAddress[0].Latitude,
            lng: this.orderAddress[0].Longitude
          })
        }
      },
      getPaths () {
        if (this.orderAddress.length === 0 && this.order.GeoType !== 13) {
          return false
        }
        let paths = []
        let address = this.orderAddress[0]
        for (let path of address.AddrSearchString.split('|')) {
          paths.push({lat: Number(path.split(':')[1]), lng: Number(path.split(':')[0])})
        }
        return paths
      },
      toggleFullScreen (val) {
        this.fullScreen = val
      }
    }
  }
</script>

<style scoped lang="scss">
  .row{
    margin-top: 16px;
    margin-bottom: 8px;
  }
  .address-input{
    width: 100%;
    display: inline-block;
    float: right;
  }
  .address-type{
    margin-left: 8px;
  }

  .header {
    display: flex;
    justify-content: space-between;
  }

  .box-t {
    border-radius: 8px;
    background-color: $color-background;
    width: 100%;
    margin-bottom:16px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoPolygon.vue